






















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
const wtK2Scan = namespace("wtK2Scan");
const common = namespace("common");
const root = namespace("root");
@Component({})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class wtK2ScanCodeException extends Vue {
  @root.State ddCodes;

  @wtK2Scan.Action queryScanException;
  @wtK2Scan.Action exportScanException;
  @wtK2Scan.State exceptionScanTypeList;
  @wtK2Scan.Getter exceptionScanTypeObj;
  @wtK2Scan.State exceptionTypeList;
  @wtK2Scan.Getter exceptionTypeObj;
  private isKaOptions: any[] = [];
  private form = {
    createTime: "",
    scanType: "",
    exceptionType: "",
    orgCode: "",
    parentOrgCode: "",
    orgType: "2",
    tyreCode: "",
    market: "",
    isKa: ""
  };
  private tableData = [];
  private dataList = [];
  private total = 0;
  // private searchParams = {};
  get searchParams() {
    let { createTime, ...others } = this.form;

    let start = undefined;
    let end = undefined;
    if (createTime) {
      start = createTime[0];
      end = createTime[1];
    }
    let input = {
      // orgType: "2",
      ...others,
      isKa: others.isKa === "" ? null : others.isKa,
      startTime: start,
      endTime: end
    };
    return input;
  }

  async mounted() {
    // await this.getData();
  }

  async created() {
    // await this.getData();
    await this.$dd.register(["SCAN_EXCEPTION", "isKA"]).query();
    this.isKaOptions = this.ddCodes["isKA"] || [];
  }
  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    try {
      let input = this.searchParams;
      let { list, total } = await this.queryScanException({
        input,
        pageInput
      });
      this.dataList = list;
      this.total = total;
      // this.searchParams = input;
    } catch (err) {
      console.error(err);
      (this as any).total = 0;
    }
  }
  handleExport() {
    (this.$refs.gtExportDialog as any).visible = true;
  }
  async exportExcelFn(params) {
    await this.exportScanException({
      input: this.searchParams,
      pageInput: {
        pageSize: this.total,
        pageNum: 1
      }
    });
  }

  // 格式化是否KA店显示
  formatIsKa(val: any) {
    const item = this.isKaOptions.find((_: any) => _.value === val);
    return item ? item.label : '-';
  }
}
